import {
  AUDIT_LOGS_FILTERABLE_FIELDS,
  type AuditLogsFilterableField,
} from '@kirin/api-client/contracts/audit-logs-table';

/**
 * URL keys for every audit-logs filterable field. Single source of truth —
 * column definitions reference this instead of hardcoding short keys.
 */
export const AUDIT_LOGS_FILTER_URL_KEYS = {
  [AUDIT_LOGS_FILTERABLE_FIELDS.TIMESTAMP]: 'ts',
  [AUDIT_LOGS_FILTERABLE_FIELDS.TABLE_NAME]: 'obj',
  [AUDIT_LOGS_FILTERABLE_FIELDS.OPERATION]: 'op',
  [AUDIT_LOGS_FILTERABLE_FIELDS.RECORD_ID]: 'oid',
  [AUDIT_LOGS_FILTERABLE_FIELDS.USER]: 'usr',
  [AUDIT_LOGS_FILTERABLE_FIELDS.CHANGES]: 'chg',
} as const satisfies Record<AuditLogsFilterableField, string>;

/** User cell/label text: name, else email, else "System". The raw id is never shown. */
export function formatAuditUserDisplay(
  userName: string | null,
  userEmail: string | null
): string {
  return userName || userEmail || 'System';
}

/** The column a group-scoped row stores its security group in (KIR-4701). */
export const SECURITY_GROUP_FIELD = 'security_group_id';

/**
 * KIR-4701: the security group a row's change was scoped to, from the row
 * itself rather than the diff — an UPDATE's diff lists only the fields that
 * changed, so it rarely carries the scope.
 */
export function auditScopeGroupId(row: {
  beforeData: Record<string, unknown> | null;
  afterData: Record<string, unknown> | null;
}): string | null {
  const id =
    row.afterData?.[SECURITY_GROUP_FIELD] ??
    row.beforeData?.[SECURITY_GROUP_FIELD];
  return typeof id === 'string' && id !== '' ? id : null;
}
